import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Данные о продуктах
const dataSource = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
      Молоко: 462,
      Шерсть: 1809,
      Яйца: 455,
      Мясо: 57,
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
      Молоко: 101,
      Шерсть: 602,
      Яйца: 21,
      Мясо: 17,
    },
  },
  {
    key: 2,
    region: "Ошская",
    counts: {
      Молоко: 347,
      Шерсть: 2220,
      Яйца: 69,
      Мясо: 51,
    },
  },
  {
    key: 3,
    region: "Таласская",
    counts: {
      Молоко: 77,
      Шерсть: 1500,
      Яйца: 23,
      Мясо: 14,
    },
  },
  {
    key: 4,
    region: "Нарынская",
    counts: {
      Молоко: 141,
      Шерсть: 2408,
      Яйца: 8.2,
      Мясо: 33.7,
    },
  },
  {
    key: 5,
    region: "Ыссык-Кульская",
    counts: {
      Молоко: 270,
      Шерсть: 1949,
      Яйца: 29.4,
      Мясо: 37.5,
    },
  },
  {
    key: 6,
    region: "Джалал-Абадская",
    counts: {
      Молоко: 372.9,
      Шерсть: 2396,
      Яйца: 77.1,
      Мясо: 16.5,
    },
  },
];

// Преобразование данных для графика
const chartData = dataSource.map(item => ({
  region: item.region,
  ...item.counts
}));

const ProductPlantsChart = () => {
  return (
    <div style={{ }}>
      <h2>Производство по областям (Тыс/Тонн)</h2>
      <BarChart
        width={800}
        height={400}
        data={chartData}
        margin={{
          top: 5, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="region" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Молоко" fill="#8884d8" />
        <Bar dataKey="Шерсть" fill="#82ca9d" />
        <Bar dataKey="Яйца" fill="#ffc658" />
        <Bar dataKey="Мясо" fill="#ff7300" />
      </BarChart>
    </div>
  );
};

export default ProductPlantsChart;
